module.exports = __webpack_public_path__ + "img/logo.8c834cf6.svg";